import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postTaskShownById,
  type PostTaskShownByIdParams,
  type PostTaskShownByIdResponse,
} from '@services/TasksService';

export type UsePostTaskShownByIdParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostTaskShownByIdResponse,
    unknown,
    string,
    PostTaskShownByIdParams,
    PostTaskShownByIdResponse
  >;
};

export const postTaskShownByIdMutationKey = 'post-task-shown-by-id';

export const usePostTaskShownById = ({
  mutationOptions,
}: UsePostTaskShownByIdParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostTaskShownByIdResponse,
    unknown,
    string,
    PostTaskShownByIdParams
  >(
    postTaskShownByIdMutationKey,
    (_url, { arg }) => postTaskShownById(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
